<vi-page [sidenavs]="true" [footer]="true">
  <vi-content body>
    <vi-panel main>
      <div class="content" content>
        <span>
          Small control with no value
          <mat-form-field mat-select-height-small>
            <mat-label>Select Simulator</mat-label>
            <mat-select [formControl]="formGroup.controls.small" fieldTextContentTooltip>
              <mat-select-trigger>
                <span>
                  {{ formGroup.controls.small?.value?.displayKey }}
                </span>
              </mat-select-trigger>
              <mat-option
                *ngFor="let option of voucherOptions"
                [value]="option"
                fieldTextContentTooltip
                >{{ option.displayKey }}</mat-option
              >
            </mat-select>
          </mat-form-field>
        </span>

        <span>
          Small control with pre-selected value
          <mat-form-field mat-select-height-small>
            <mat-label>Select Simulator</mat-label>
            <mat-select [formControl]="formGroup.controls.smallValue" fieldTextContentTooltip>
              <mat-select-trigger>
                <span>
                  {{ formGroup.controls.smallValue?.value?.displayKey }}
                </span>
              </mat-select-trigger>
              <mat-option
                *ngFor="let option of voucherOptions"
                [value]="option"
                fieldTextContentTooltip
                >{{ option.displayKey }}</mat-option
              >
            </mat-select>
          </mat-form-field>
        </span>

        <span>
          Small control disabled
          <mat-form-field mat-select-height-small>
            <mat-label>Select Simulator</mat-label>
            <mat-select
              [disabled]="true"
              [formControl]="formGroup.controls.smallDisabled"
              fieldTextContentTooltip
            >
              <mat-select-trigger>
                <span>
                  {{ formGroup.controls.smallDisabled?.value?.displayKey }}
                </span>
              </mat-select-trigger>
              <mat-option
                *ngFor="let option of voucherOptions"
                [value]="option"
                fieldTextContentTooltip
                >{{ option.displayKey }}</mat-option
              >
            </mat-select>
          </mat-form-field>
        </span>

        <span>
          Small control disabled with pre-selected value
          <mat-form-field mat-select-height-small>
            <mat-label>Select Simulator</mat-label>
            <mat-select
              [disabled]="true"
              [formControl]="formGroup.controls.smallDisabledValue"
              fieldTextContentTooltip
            >
              <mat-select-trigger>
                <span>
                  {{ formGroup.controls.smallDisabledValue?.value?.displayKey }}
                </span>
              </mat-select-trigger>
              <mat-option
                *ngFor="let option of voucherOptions"
                [value]="option"
                fieldTextContentTooltip
                >{{ option.displayKey }}</mat-option
              >
            </mat-select>
          </mat-form-field>
        </span>

        <span>
          Small control with error
          <mat-form-field mat-select-height-small>
            <mat-label>Select Simulator</mat-label>
            <mat-select [formControl]="formGroup.controls.smallError" fieldTextContentTooltip>
              <mat-select-trigger>
                <span>
                  {{ formGroup.controls.smallError?.value?.displayKey }}
                </span>
              </mat-select-trigger>
              <mat-option
                *ngFor="let option of voucherOptions"
                [value]="option"
                fieldTextContentTooltip
                >{{ option.displayKey }}</mat-option
              >
            </mat-select>
            <mat-error *ngIf="formGroup.controls.smallError.hasError('pattern')"
              >Incorrect value</mat-error
            >
          </mat-form-field>
        </span>

        <span>
          Small control with two errors
          <mat-form-field mat-select-height-small>
            <mat-label>Select Simulator</mat-label>
            <mat-select [formControl]="formGroup.controls.smallError" fieldTextContentTooltip>
              <mat-select-trigger>
                <span>
                  {{ formGroup.controls.smallError?.value?.displayKey }}
                </span>
              </mat-select-trigger>
              <mat-option
                *ngFor="let option of voucherOptions"
                [value]="option"
                fieldTextContentTooltip
                >{{ option.displayKey }}</mat-option
              >
            </mat-select>
            <mat-error *ngIf="formGroup.controls.smallError.hasError('pattern')"
              >Incorrect value</mat-error
            >
            <mat-error *ngIf="formGroup.controls.smallError.hasError('pattern')"
              >Invalid Simulator</mat-error
            >
          </mat-form-field>
        </span>

        <span>
          Small control with no value + description
          <mat-form-field mat-select-height-small>
            <mat-label>Select Simulator</mat-label>
            <mat-select [formControl]="formGroup.controls.small" fieldTextContentTooltip>
              <mat-select-trigger>
                <span>
                  {{ formGroup.controls.small?.value?.displayKey }}
                </span>
              </mat-select-trigger>
              <mat-option
                *ngFor="let option of voucherOptions"
                [value]="option"
                fieldTextContentTooltip
                >{{ option.displayKey }}</mat-option
              >
            </mat-select>
            <span mat-select-description>Description</span>
          </mat-form-field>
        </span>

        <span>
          Small control with pre-selected value + description
          <mat-form-field mat-select-height-small>
            <mat-label>Select Simulator</mat-label>
            <mat-select [formControl]="formGroup.controls.smallValue" fieldTextContentTooltip>
              <mat-select-trigger>
                <span>
                  {{ formGroup.controls.smallValue?.value?.displayKey }}
                </span>
              </mat-select-trigger>
              <mat-option
                *ngFor="let option of voucherOptions"
                [value]="option"
                fieldTextContentTooltip
                >{{ option.displayKey }}</mat-option
              >
            </mat-select>
            <span mat-select-description>Description</span>
          </mat-form-field>
        </span>

        <span>
          Small control disabled + description
          <mat-form-field mat-select-height-small>
            <mat-label>Select Simulator</mat-label>
            <mat-select
              [disabled]="true"
              [formControl]="formGroup.controls.smallDisabled"
              fieldTextContentTooltip
            >
              <mat-select-trigger>
                <span>
                  {{ formGroup.controls.smallDisabled?.value?.displayKey }}
                </span>
              </mat-select-trigger>
              <mat-option
                *ngFor="let option of voucherOptions"
                [value]="option"
                fieldTextContentTooltip
                >{{ option.displayKey }}</mat-option
              >
            </mat-select>
            <span mat-select-description>Description</span>
          </mat-form-field>
        </span>

        <span>
          Small control disabled with pre-selected value + description
          <mat-form-field mat-select-height-small>
            <mat-label>Select Simulator</mat-label>
            <mat-select
              [disabled]="true"
              [formControl]="formGroup.controls.smallDisabledValue"
              fieldTextContentTooltip
            >
              <mat-select-trigger>
                <span>
                  {{ formGroup.controls.smallDisabledValue?.value?.displayKey }}
                </span>
              </mat-select-trigger>
              <mat-option
                *ngFor="let option of voucherOptions"
                [value]="option"
                fieldTextContentTooltip
                >{{ option.displayKey }}</mat-option
              >
            </mat-select>
            <span mat-select-description>Description</span>
          </mat-form-field>
        </span>

        <span>
          Small control with error + description
          <mat-form-field mat-select-height-small>
            <mat-label>Select Simulator</mat-label>
            <mat-select [formControl]="formGroup.controls.smallError" fieldTextContentTooltip>
              <mat-select-trigger>
                <span>
                  {{ formGroup.controls.smallError?.value?.displayKey }}
                </span>
              </mat-select-trigger>
              <mat-option
                *ngFor="let option of voucherOptions"
                [value]="option"
                fieldTextContentTooltip
                >{{ option.displayKey }}</mat-option
              >
            </mat-select>
            <span mat-select-description>Description</span>
            <mat-error *ngIf="formGroup.controls.smallError.hasError('pattern')"
              >Incorrect value</mat-error
            >
          </mat-form-field>
        </span>

        <span>
          Small control with two errors + description
          <mat-form-field mat-select-height-small>
            <mat-label>Select Simulator</mat-label>
            <mat-select [formControl]="formGroup.controls.smallError" fieldTextContentTooltip>
              <mat-select-trigger>
                <span>
                  {{ formGroup.controls.smallError?.value?.displayKey }}
                </span>
              </mat-select-trigger>
              <mat-option
                *ngFor="let option of voucherOptions"
                [value]="option"
                fieldTextContentTooltip
                >{{ option.displayKey }}</mat-option
              >
            </mat-select>
            <span mat-select-description>Description</span>
            <mat-error *ngIf="formGroup.controls.smallError.hasError('pattern')"
              >Incorrect value</mat-error
            >
            <mat-error *ngIf="formGroup.controls.smallError.hasError('pattern')"
              >Invalid Simulator</mat-error
            >
          </mat-form-field>
        </span>

        <span>
          Small frameless control
          <mat-form-field mat-select-height-small mat-select-frameless>
            <mat-label>Select Simulator</mat-label>
            <mat-select [formControl]="formGroup.controls.smallFrameless" fieldTextContentTooltip>
              <mat-select-trigger>
                <span>
                  {{ formGroup.controls.smallFrameless?.value?.displayKey }}
                </span>
              </mat-select-trigger>
              <mat-option
                *ngFor="let option of voucherOptions"
                [value]="option"
                fieldTextContentTooltip
                >{{ option.displayKey }}</mat-option
              >
            </mat-select>
          </mat-form-field>
        </span>

        <span>
          Small frameless control with pre-selected value
          <mat-form-field mat-select-height-small mat-select-frameless>
            <mat-label>Select Simulator</mat-label>
            <mat-select
              [formControl]="formGroup.controls.smallFramelessValue"
              fieldTextContentTooltip
            >
              <mat-select-trigger>
                <span>
                  {{ formGroup.controls.smallFramelessValue?.value?.displayKey }}
                </span>
              </mat-select-trigger>
              <mat-option
                *ngFor="let option of voucherOptions"
                [value]="option"
                fieldTextContentTooltip
                >{{ option.displayKey }}</mat-option
              >
            </mat-select>
          </mat-form-field>
        </span>

        <span>
          Small frameless control disabled
          <mat-form-field mat-select-height-small mat-select-frameless>
            <mat-label>Select Simulator</mat-label>
            <mat-select
              [disabled]="true"
              [formControl]="formGroup.controls.smallFramelessDisabled"
              fieldTextContentTooltip
            >
              <mat-select-trigger>
                <span>
                  {{ formGroup.controls.smallFramelessDisabled?.value?.displayKey }}
                </span>
              </mat-select-trigger>
              <mat-option
                *ngFor="let option of voucherOptions"
                [value]="option"
                fieldTextContentTooltip
                >{{ option.displayKey }}</mat-option
              >
            </mat-select>
          </mat-form-field>
        </span>

        <span>
          Small frameless control disabled value
          <mat-form-field mat-select-height-small mat-select-frameless>
            <mat-label>Select Simulator</mat-label>
            <mat-select
              [disabled]="true"
              [formControl]="formGroup.controls.smallFramelessDisabledValue"
              fieldTextContentTooltip
            >
              <mat-select-trigger>
                <span>
                  {{ formGroup.controls.smallFramelessDisabledValue?.value?.displayKey }}
                </span>
              </mat-select-trigger>
              <mat-option
                *ngFor="let option of voucherOptions"
                [value]="option"
                fieldTextContentTooltip
                >{{ option.displayKey }}</mat-option
              >
            </mat-select>
          </mat-form-field>
        </span>

        <span>
          Small frameless control with error
          <mat-form-field mat-select-height-small mat-select-frameless>
            <mat-label>Select Simulator</mat-label>
            <mat-select
              [formControl]="formGroup.controls.smallFramelessError"
              fieldTextContentTooltip
            >
              <mat-select-trigger>
                <span>
                  {{ formGroup.controls.smallFramelessError?.value?.displayKey }}
                </span>
              </mat-select-trigger>
              <mat-option
                *ngFor="let option of voucherOptions"
                [value]="option"
                fieldTextContentTooltip
                >{{ option.displayKey }}</mat-option
              >
            </mat-select>
            <mat-error *ngIf="formGroup.controls.smallFramelessError.hasError('pattern')"
              >Incorrect value</mat-error
            >
          </mat-form-field>
        </span>

        <span>
          Small frameless control with two error
          <mat-form-field mat-select-height-small mat-select-frameless>
            <mat-label>Select Simulator</mat-label>
            <mat-select
              [formControl]="formGroup.controls.smallFramelessError"
              fieldTextContentTooltip
            >
              <mat-select-trigger>
                <span>
                  {{ formGroup.controls.smallFramelessError?.value?.displayKey }}
                </span>
              </mat-select-trigger>
              <mat-option
                *ngFor="let option of voucherOptions"
                [value]="option"
                fieldTextContentTooltip
                >{{ option.displayKey }}</mat-option
              >
            </mat-select>
            <mat-error *ngIf="formGroup.controls.smallFramelessError.hasError('pattern')"
              >Incorrect value</mat-error
            >
            <mat-error *ngIf="formGroup.controls.smallFramelessError.hasError('pattern')"
              >Invalid Simulator</mat-error
            >
          </mat-form-field>
        </span>

        <span>
          Small frameless control + description
          <mat-form-field mat-select-height-small mat-select-frameless>
            <mat-label>Select Simulator</mat-label>
            <mat-select [formControl]="formGroup.controls.smallFrameless" fieldTextContentTooltip>
              <mat-select-trigger>
                <span>
                  {{ formGroup.controls.smallFrameless?.value?.displayKey }}
                </span>
              </mat-select-trigger>
              <mat-option
                *ngFor="let option of voucherOptions"
                [value]="option"
                fieldTextContentTooltip
                >{{ option.displayKey }}</mat-option
              >
            </mat-select>
            <span mat-select-description>Description</span>
          </mat-form-field>
        </span>

        <span>
          Small frameless control with pre-selected value + description
          <mat-form-field mat-select-height-small mat-select-frameless>
            <mat-label>Select Simulator</mat-label>
            <mat-select
              [formControl]="formGroup.controls.smallFramelessValue"
              fieldTextContentTooltip
            >
              <mat-select-trigger>
                <span>
                  {{ formGroup.controls.smallFramelessValue?.value?.displayKey }}
                </span>
              </mat-select-trigger>
              <mat-option
                *ngFor="let option of voucherOptions"
                [value]="option"
                fieldTextContentTooltip
                >{{ option.displayKey }}</mat-option
              >
            </mat-select>
            <span mat-select-description>Description</span>
          </mat-form-field>
        </span>

        <span>
          Small frameless control disabled + description
          <mat-form-field mat-select-height-small mat-select-frameless>
            <mat-label>Select Simulator</mat-label>
            <mat-select
              [disabled]="true"
              [formControl]="formGroup.controls.smallFramelessDisabled"
              fieldTextContentTooltip
            >
              <mat-select-trigger>
                <span>
                  {{ formGroup.controls.smallFramelessDisabled?.value?.displayKey }}
                </span>
              </mat-select-trigger>
              <mat-option
                *ngFor="let option of voucherOptions"
                [value]="option"
                fieldTextContentTooltip
                >{{ option.displayKey }}</mat-option
              >
            </mat-select>
            <span mat-select-description>Description</span>
          </mat-form-field>
        </span>

        <span>
          Small frameless control disabled value + description
          <mat-form-field mat-select-height-small mat-select-frameless>
            <mat-label>Select Simulator</mat-label>
            <mat-select
              [disabled]="true"
              [formControl]="formGroup.controls.smallFramelessDisabledValue"
              fieldTextContentTooltip
            >
              <mat-select-trigger>
                <span>
                  {{ formGroup.controls.smallFramelessDisabledValue?.value?.displayKey }}
                </span>
              </mat-select-trigger>
              <mat-option
                *ngFor="let option of voucherOptions"
                [value]="option"
                fieldTextContentTooltip
                >{{ option.displayKey }}</mat-option
              >
            </mat-select>
            <span mat-select-description>Description</span>
          </mat-form-field>
        </span>

        <span>
          Small frameless control with error + description
          <mat-form-field mat-select-height-small mat-select-frameless>
            <mat-label>Select Simulator</mat-label>
            <mat-select
              [formControl]="formGroup.controls.smallFramelessError"
              fieldTextContentTooltip
            >
              <mat-select-trigger>
                <span>
                  {{ formGroup.controls.smallFramelessError?.value?.displayKey }}
                </span>
              </mat-select-trigger>
              <mat-option
                *ngFor="let option of voucherOptions"
                [value]="option"
                fieldTextContentTooltip
                >{{ option.displayKey }}</mat-option
              >
            </mat-select>
            <span mat-select-description>Description</span>
            <mat-error *ngIf="formGroup.controls.smallFramelessError.hasError('pattern')"
              >Incorrect value</mat-error
            >
          </mat-form-field>
        </span>

        <span>
          Small frameless control with two error + description
          <mat-form-field mat-select-height-small mat-select-frameless>
            <mat-label>Select Simulator</mat-label>
            <mat-select
              [formControl]="formGroup.controls.smallFramelessError"
              fieldTextContentTooltip
            >
              <mat-select-trigger>
                <span>
                  {{ formGroup.controls.smallFramelessError?.value?.displayKey }}
                </span>
              </mat-select-trigger>
              <mat-option
                *ngFor="let option of voucherOptions"
                [value]="option"
                fieldTextContentTooltip
                >{{ option.displayKey }}</mat-option
              >
            </mat-select>
            <span mat-select-description>Description</span>
            <mat-error *ngIf="formGroup.controls.smallFramelessError.hasError('pattern')"
              >Incorrect value</mat-error
            >
            <mat-error *ngIf="formGroup.controls.smallFramelessError.hasError('pattern')"
              >Invalid Simulator</mat-error
            >
          </mat-form-field>
        </span>
      </div>
    </vi-panel>

    <vi-panel main>
      <div class="content" content>
        <span>
          Medium control with no value
          <mat-form-field mat-select-height-medium>
            <mat-label>Select Simulator</mat-label>
            <mat-select [formControl]="formGroup.controls.medium" fieldTextContentTooltip>
              <mat-select-trigger>
                <span>
                  {{ formGroup.controls.medium?.value?.displayKey }}
                </span>
              </mat-select-trigger>
              <mat-option
                *ngFor="let option of voucherOptions"
                [value]="option"
                fieldTextContentTooltip
                >{{ option.displayKey }}</mat-option
              >
            </mat-select>
          </mat-form-field>
        </span>

        <span>
          Medium control with pre-selected value
          <mat-form-field mat-select-height-medium>
            <mat-label>Select Simulator</mat-label>
            <mat-select [formControl]="formGroup.controls.mediumValue" fieldTextContentTooltip>
              <mat-select-trigger>
                <span>
                  {{ formGroup.controls.mediumValue?.value?.displayKey }}
                </span>
              </mat-select-trigger>
              <mat-option
                *ngFor="let option of voucherOptions"
                [value]="option"
                fieldTextContentTooltip
                >{{ option.displayKey }}</mat-option
              >
            </mat-select>
          </mat-form-field>
        </span>

        <span>
          Medium control disabled
          <mat-form-field mat-select-height-medium>
            <mat-label>Select Simulator</mat-label>
            <mat-select
              [disabled]="true"
              [formControl]="formGroup.controls.mediumDisabled"
              fieldTextContentTooltip
            >
              <mat-select-trigger>
                <span>
                  {{ formGroup.controls.mediumDisabled?.value?.displayKey }}
                </span>
              </mat-select-trigger>
              <mat-option
                *ngFor="let option of voucherOptions"
                [value]="option"
                fieldTextContentTooltip
                >{{ option.displayKey }}</mat-option
              >
            </mat-select>
          </mat-form-field>
        </span>

        <span>
          Medium control disabled with pre-selected value
          <mat-form-field mat-select-height-medium>
            <mat-label>Select Simulator</mat-label>
            <mat-select
              [disabled]="true"
              [formControl]="formGroup.controls.mediumDisabledValue"
              fieldTextContentTooltip
            >
              <mat-select-trigger>
                <span>
                  {{ formGroup.controls.mediumDisabledValue?.value?.displayKey }}
                </span>
              </mat-select-trigger>
              <mat-option
                *ngFor="let option of voucherOptions"
                [value]="option"
                fieldTextContentTooltip
                >{{ option.displayKey }}</mat-option
              >
            </mat-select>
          </mat-form-field>
        </span>

        <span>
          Medium control with error
          <mat-form-field mat-select-height-medium>
            <mat-label>Select Simulator</mat-label>
            <mat-select [formControl]="formGroup.controls.mediumError" fieldTextContentTooltip>
              <mat-select-trigger>
                <span>
                  {{ formGroup.controls.mediumError?.value?.displayKey }}
                </span>
              </mat-select-trigger>
              <mat-option
                *ngFor="let option of voucherOptions"
                [value]="option"
                fieldTextContentTooltip
                >{{ option.displayKey }}</mat-option
              >
            </mat-select>
            <mat-error *ngIf="formGroup.controls.mediumError.hasError('pattern')"
              >Incorrect value</mat-error
            >
          </mat-form-field>
        </span>

        <span>
          Medium control with two errors
          <mat-form-field mat-select-height-medium>
            <mat-label>Select Simulator</mat-label>
            <mat-select [formControl]="formGroup.controls.mediumError" fieldTextContentTooltip>
              <mat-select-trigger>
                <span>
                  {{ formGroup.controls.mediumError?.value?.displayKey }}
                </span>
              </mat-select-trigger>
              <mat-option
                *ngFor="let option of voucherOptions"
                [value]="option"
                fieldTextContentTooltip
                >{{ option.displayKey }}</mat-option
              >
            </mat-select>
            <mat-error *ngIf="formGroup.controls.mediumError.hasError('pattern')"
              >Incorrect value</mat-error
            >
            <mat-error *ngIf="formGroup.controls.mediumError.hasError('pattern')"
              >Invalid Simulator</mat-error
            >
          </mat-form-field>
        </span>

        <span>
          Medium control with no value + description
          <mat-form-field mat-select-height-medium>
            <mat-label>Select Simulator</mat-label>
            <mat-select [formControl]="formGroup.controls.medium" fieldTextContentTooltip>
              <mat-select-trigger>
                <span>
                  {{ formGroup.controls.medium?.value?.displayKey }}
                </span>
              </mat-select-trigger>
              <mat-option
                *ngFor="let option of voucherOptions"
                [value]="option"
                fieldTextContentTooltip
                >{{ option.displayKey }}</mat-option
              >
            </mat-select>
            <span mat-select-description>Description</span>
          </mat-form-field>
        </span>

        <span>
          Medium control with pre-selected value + description
          <mat-form-field mat-select-height-medium>
            <mat-label>Select Simulator</mat-label>
            <mat-select [formControl]="formGroup.controls.mediumValue">
              <mat-select-trigger>
                <span>
                  {{ formGroup.controls.mediumValue?.value?.displayKey }}
                </span>
              </mat-select-trigger>
              <mat-option
                *ngFor="let option of voucherOptions"
                [value]="option"
                fieldTextContentTooltip
                >{{ option.displayKey }}</mat-option
              >
            </mat-select>
            <span mat-select-description>Description</span>
          </mat-form-field>
        </span>

        <span>
          Medium control disabled + description
          <mat-form-field mat-select-height-medium>
            <mat-label>Select Simulator</mat-label>
            <mat-select [disabled]="true" [formControl]="formGroup.controls.mediumDisabled">
              <mat-select-trigger>
                <span>
                  {{ formGroup.controls.mediumDisabled?.value?.displayKey }}
                </span>
              </mat-select-trigger>
              <mat-option
                *ngFor="let option of voucherOptions"
                [value]="option"
                fieldTextContentTooltip
                >{{ option.displayKey }}</mat-option
              >
            </mat-select>
            <span mat-select-description>Description</span>
          </mat-form-field>
        </span>

        <span>
          Medium control disabled with pre-selected value + description
          <mat-form-field mat-select-height-medium>
            <mat-label>Select Simulator</mat-label>
            <mat-select [disabled]="true" [formControl]="formGroup.controls.mediumDisabledValue">
              <mat-select-trigger>
                <span>
                  {{ formGroup.controls.mediumDisabledValue?.value?.displayKey }}
                </span>
              </mat-select-trigger>
              <mat-option
                *ngFor="let option of voucherOptions"
                [value]="option"
                fieldTextContentTooltip
                >{{ option.displayKey }}</mat-option
              >
            </mat-select>
            <span mat-select-description>Description</span>
          </mat-form-field>
        </span>

        <span>
          Medium control with error + description
          <mat-form-field mat-select-height-medium>
            <mat-label>Select Simulator</mat-label>
            <mat-select [formControl]="formGroup.controls.mediumError">
              <mat-select-trigger>
                <span>
                  {{ formGroup.controls.mediumError?.value?.displayKey }}
                </span>
              </mat-select-trigger>
              <mat-option
                *ngFor="let option of voucherOptions"
                [value]="option"
                fieldTextContentTooltip
                >{{ option.displayKey }}</mat-option
              >
            </mat-select>
            <span mat-select-description>Description</span>
            <mat-error *ngIf="formGroup.controls.mediumError.hasError('pattern')"
              >Incorrect value</mat-error
            >
          </mat-form-field>
        </span>

        <span>
          Medium control with two errors + description
          <mat-form-field mat-select-height-medium>
            <mat-label>Select Simulator</mat-label>
            <mat-select [formControl]="formGroup.controls.mediumError">
              <mat-select-trigger>
                <span>
                  {{ formGroup.controls.mediumError?.value?.displayKey }}
                </span>
              </mat-select-trigger>
              <mat-option
                *ngFor="let option of voucherOptions"
                [value]="option"
                fieldTextContentTooltip
                >{{ option.displayKey }}</mat-option
              >
            </mat-select>
            <span mat-select-description>Description</span>
            <mat-error *ngIf="formGroup.controls.mediumError.hasError('pattern')"
              >Incorrect value</mat-error
            >
            <mat-error *ngIf="formGroup.controls.mediumError.hasError('pattern')"
              >Invalid Simulator</mat-error
            >
          </mat-form-field>
        </span>

        <span>
          Medium frameless control
          <mat-form-field mat-select-height-medium mat-select-frameless>
            <mat-label>Select Simulator</mat-label>
            <mat-select [formControl]="formGroup.controls.mediumFrameless">
              <mat-select-trigger>
                <span>
                  {{ formGroup.controls.mediumFrameless?.value?.displayKey }}
                </span>
              </mat-select-trigger>
              <mat-option
                *ngFor="let option of voucherOptions"
                [value]="option"
                fieldTextContentTooltip
                >{{ option.displayKey }}</mat-option
              >
            </mat-select>
          </mat-form-field>
        </span>

        <span>
          Medium frameless control with pre-selected value
          <mat-form-field mat-select-height-medium mat-select-frameless>
            <mat-label>Select Simulator</mat-label>
            <mat-select [formControl]="formGroup.controls.mediumFramelessValue">
              <mat-select-trigger>
                <span>
                  {{ formGroup.controls.mediumFramelessValue?.value?.displayKey }}
                </span>
              </mat-select-trigger>
              <mat-option
                *ngFor="let option of voucherOptions"
                [value]="option"
                fieldTextContentTooltip
                >{{ option.displayKey }}</mat-option
              >
            </mat-select>
          </mat-form-field>
        </span>

        <span>
          Medium frameless control disabled
          <mat-form-field mat-select-height-medium mat-select-frameless>
            <mat-label>Select Simulator</mat-label>
            <mat-select
              [disabled]="true"
              [formControl]="formGroup.controls.mediumFramelessDisabled"
            >
              <mat-select-trigger>
                <span>
                  {{ formGroup.controls.mediumFramelessDisabled?.value?.displayKey }}
                </span>
              </mat-select-trigger>
              <mat-option
                *ngFor="let option of voucherOptions"
                [value]="option"
                fieldTextContentTooltip
                >{{ option.displayKey }}</mat-option
              >
            </mat-select>
          </mat-form-field>
        </span>

        <span>
          Medium frameless control disabled value
          <mat-form-field mat-select-height-medium mat-select-frameless>
            <mat-label>Select Simulator</mat-label>
            <mat-select
              [disabled]="true"
              [formControl]="formGroup.controls.mediumFramelessDisabledValue"
            >
              <mat-select-trigger>
                <span>
                  {{ formGroup.controls.mediumFramelessDisabledValue?.value?.displayKey }}
                </span>
              </mat-select-trigger>
              <mat-option
                *ngFor="let option of voucherOptions"
                [value]="option"
                fieldTextContentTooltip
                >{{ option.displayKey }}</mat-option
              >
            </mat-select>
          </mat-form-field>
        </span>

        <span>
          Medium frameless control with error
          <mat-form-field mat-select-height-medium mat-select-frameless>
            <mat-label>Select Simulator</mat-label>
            <mat-select [formControl]="formGroup.controls.mediumFramelessError">
              <mat-select-trigger>
                <span>
                  {{ formGroup.controls.mediumFramelessError?.value?.displayKey }}
                </span>
              </mat-select-trigger>
              <mat-option
                *ngFor="let option of voucherOptions"
                [value]="option"
                fieldTextContentTooltip
                >{{ option.displayKey }}</mat-option
              >
            </mat-select>
            <mat-error *ngIf="formGroup.controls.mediumFramelessError.hasError('pattern')"
              >Incorrect value</mat-error
            >
          </mat-form-field>
        </span>

        <span>
          Medium frameless control with two error
          <mat-form-field mat-select-height-medium mat-select-frameless>
            <mat-label>Select Simulator</mat-label>
            <mat-select [formControl]="formGroup.controls.mediumFramelessError">
              <mat-select-trigger>
                <span>
                  {{ formGroup.controls.mediumFramelessError?.value?.displayKey }}
                </span>
              </mat-select-trigger>
              <mat-option
                *ngFor="let option of voucherOptions"
                [value]="option"
                fieldTextContentTooltip
                >{{ option.displayKey }}</mat-option
              >
            </mat-select>
            <mat-error *ngIf="formGroup.controls.mediumFramelessError.hasError('pattern')"
              >Incorrect value</mat-error
            >
            <mat-error *ngIf="formGroup.controls.mediumFramelessError.hasError('pattern')"
              >Invalid Simulator</mat-error
            >
          </mat-form-field>
        </span>

        <span>
          Medium frameless control + description
          <mat-form-field mat-select-height-medium mat-select-frameless>
            <mat-label>Select Simulator</mat-label>
            <mat-select [formControl]="formGroup.controls.mediumFrameless">
              <mat-select-trigger>
                <span>
                  {{ formGroup.controls.mediumFrameless?.value?.displayKey }}
                </span>
              </mat-select-trigger>
              <mat-option
                *ngFor="let option of voucherOptions"
                [value]="option"
                fieldTextContentTooltip
                >{{ option.displayKey }}</mat-option
              >
            </mat-select>
            <span mat-select-description>Description</span>
          </mat-form-field>
        </span>

        <span>
          Medium frameless control with pre-selected value + description
          <mat-form-field mat-select-height-medium mat-select-frameless>
            <mat-label>Select Simulator</mat-label>
            <mat-select [formControl]="formGroup.controls.mediumFramelessValue">
              <mat-select-trigger>
                <span>
                  {{ formGroup.controls.mediumFramelessValue?.value?.displayKey }}
                </span>
              </mat-select-trigger>
              <mat-option
                *ngFor="let option of voucherOptions"
                [value]="option"
                fieldTextContentTooltip
                >{{ option.displayKey }}</mat-option
              >
            </mat-select>
            <span mat-select-description>Description</span>
          </mat-form-field>
        </span>

        <span>
          Medium frameless control disabled + description
          <mat-form-field mat-select-height-medium mat-select-frameless>
            <mat-label>Select Simulator</mat-label>
            <mat-select
              [disabled]="true"
              [formControl]="formGroup.controls.mediumFramelessDisabled"
            >
              <mat-select-trigger>
                <span>
                  {{ formGroup.controls.mediumFramelessDisabled?.value?.displayKey }}
                </span>
              </mat-select-trigger>
              <mat-option
                *ngFor="let option of voucherOptions"
                [value]="option"
                fieldTextContentTooltip
                >{{ option.displayKey }}</mat-option
              >
            </mat-select>
            <span mat-select-description>Description</span>
          </mat-form-field>
        </span>

        <span>
          Medium frameless control disabled value + description
          <mat-form-field mat-select-height-medium mat-select-frameless>
            <mat-label>Select Simulator</mat-label>
            <mat-select
              [disabled]="true"
              [formControl]="formGroup.controls.mediumFramelessDisabledValue"
            >
              <mat-select-trigger>
                <span>
                  {{ formGroup.controls.mediumFramelessDisabledValue?.value?.displayKey }}
                </span>
              </mat-select-trigger>
              <mat-option
                *ngFor="let option of voucherOptions"
                [value]="option"
                fieldTextContentTooltip
                >{{ option.displayKey }}</mat-option
              >
            </mat-select>
            <span mat-select-description>Description</span>
          </mat-form-field>
        </span>

        <span>
          Medium frameless control with error + description
          <mat-form-field mat-select-height-medium mat-select-frameless>
            <mat-label>Select Simulator</mat-label>
            <mat-select [formControl]="formGroup.controls.mediumFramelessError">
              <mat-select-trigger>
                <span>
                  {{ formGroup.controls.mediumFramelessError?.value?.displayKey }}
                </span>
              </mat-select-trigger>
              <mat-option
                *ngFor="let option of voucherOptions"
                [value]="option"
                fieldTextContentTooltip
                >{{ option.displayKey }}</mat-option
              >
            </mat-select>
            <span mat-select-description>Description</span>
            <mat-error *ngIf="formGroup.controls.mediumFramelessError.hasError('pattern')"
              >Incorrect value</mat-error
            >
          </mat-form-field>
        </span>

        <span>
          Medium frameless control with two error + description
          <mat-form-field mat-select-height-medium mat-select-frameless>
            <mat-label>Select Simulator</mat-label>
            <mat-select [formControl]="formGroup.controls.mediumFramelessError">
              <mat-select-trigger>
                <span>
                  {{ formGroup.controls.mediumFramelessError?.value?.displayKey }}
                </span>
              </mat-select-trigger>
              <mat-option
                *ngFor="let option of voucherOptions"
                [value]="option"
                fieldTextContentTooltip
                >{{ option.displayKey }}</mat-option
              >
            </mat-select>
            <span mat-select-description>Description</span>
            <mat-error *ngIf="formGroup.controls.mediumFramelessError.hasError('pattern')"
              >Incorrect value</mat-error
            >
            <mat-error *ngIf="formGroup.controls.mediumFramelessError.hasError('pattern')"
              >Invalid Simulator</mat-error
            >
          </mat-form-field>
        </span>
      </div>
    </vi-panel>

    <vi-panel main>
      <div class="content" content>
        <span>
          Large control with no value
          <mat-form-field mat-select-height-large>
            <mat-label>Select Simulator</mat-label>
            <mat-select [formControl]="formGroup.controls.large">
              <mat-select-trigger>
                <span>
                  {{ formGroup.controls.large?.value?.displayKey }}
                </span>
              </mat-select-trigger>
              <mat-option
                *ngFor="let option of voucherOptions"
                [value]="option"
                fieldTextContentTooltip
                >{{ option.displayKey }}</mat-option
              >
            </mat-select>
          </mat-form-field>
        </span>

        <span>
          Large control with pre-selected value
          <mat-form-field mat-select-height-large>
            <mat-label>Select Simulator</mat-label>
            <mat-select [formControl]="formGroup.controls.largeValue">
              <mat-select-trigger>
                <span>
                  {{ formGroup.controls.largeValue?.value?.displayKey }}
                </span>
              </mat-select-trigger>
              <mat-option
                *ngFor="let option of voucherOptions"
                [value]="option"
                fieldTextContentTooltip
                >{{ option.displayKey }}</mat-option
              >
            </mat-select>
          </mat-form-field>
        </span>

        <span>
          Large control disabled
          <mat-form-field mat-select-height-large>
            <mat-label>Select Simulator</mat-label>
            <mat-select [disabled]="true" [formControl]="formGroup.controls.largeDisabled">
              <mat-select-trigger>
                <span>
                  {{ formGroup.controls.largeDisabled?.value?.displayKey }}
                </span>
              </mat-select-trigger>
              <mat-option
                *ngFor="let option of voucherOptions"
                [value]="option"
                fieldTextContentTooltip
                >{{ option.displayKey }}</mat-option
              >
            </mat-select>
          </mat-form-field>
        </span>

        <span>
          Large control disabled with pre-selected value
          <mat-form-field mat-select-height-large>
            <mat-label>Select Simulator</mat-label>
            <mat-select [disabled]="true" [formControl]="formGroup.controls.largeDisabledValue">
              <mat-select-trigger>
                <span>
                  {{ formGroup.controls.largeDisabledValue?.value?.displayKey }}
                </span>
              </mat-select-trigger>
              <mat-option
                *ngFor="let option of voucherOptions"
                [value]="option"
                fieldTextContentTooltip
                >{{ option.displayKey }}</mat-option
              >
            </mat-select>
          </mat-form-field>
        </span>

        <span>
          Large control with error
          <mat-form-field mat-select-height-large>
            <mat-label>Select Simulator</mat-label>
            <mat-select [formControl]="formGroup.controls.largeError">
              <mat-select-trigger>
                <span>
                  {{ formGroup.controls.largeError?.value?.displayKey }}
                </span>
              </mat-select-trigger>
              <mat-option
                *ngFor="let option of voucherOptions"
                [value]="option"
                fieldTextContentTooltip
                >{{ option.displayKey }}</mat-option
              >
            </mat-select>
            <mat-error *ngIf="formGroup.controls.largeError.hasError('pattern')"
              >Incorrect value</mat-error
            >
          </mat-form-field>
        </span>

        <span>
          Large control with two errors
          <mat-form-field mat-select-height-large>
            <mat-label>Select Simulator</mat-label>
            <mat-select [formControl]="formGroup.controls.largeError">
              <mat-select-trigger>
                <span>
                  {{ formGroup.controls.largeError?.value?.displayKey }}
                </span>
              </mat-select-trigger>
              <mat-option *ngFor="let option of voucherOptions" [value]="option">{{
                option.displayKey
              }}</mat-option>
            </mat-select>
            <mat-error *ngIf="formGroup.controls.largeError.hasError('pattern')"
              >Incorrect value</mat-error
            >
            <mat-error *ngIf="formGroup.controls.largeError.hasError('pattern')"
              >Invalid Simulator</mat-error
            >
          </mat-form-field>
        </span>

        <span>
          Large control with no value + description
          <mat-form-field mat-select-height-large>
            <mat-label>Select Simulator</mat-label>
            <mat-select [formControl]="formGroup.controls.large">
              <mat-select-trigger>
                <span>
                  {{ formGroup.controls.large?.value?.displayKey }}
                </span>
              </mat-select-trigger>
              <mat-option *ngFor="let option of voucherOptions" [value]="option">{{
                option.displayKey
              }}</mat-option>
            </mat-select>
            <span mat-select-description>Description</span>
          </mat-form-field>
        </span>

        <span>
          Large control with pre-selected value + description
          <mat-form-field mat-select-height-large>
            <mat-label>Select Simulator</mat-label>
            <mat-select [formControl]="formGroup.controls.largeValue">
              <mat-select-trigger>
                <span>
                  {{ formGroup.controls.largeValue?.value?.displayKey }}
                </span>
              </mat-select-trigger>
              <mat-option *ngFor="let option of voucherOptions" [value]="option">{{
                option.displayKey
              }}</mat-option>
            </mat-select>
            <span mat-select-description>Description</span>
          </mat-form-field>
        </span>

        <span>
          Large control disabled + description
          <mat-form-field mat-select-height-large>
            <mat-label>Select Simulator</mat-label>
            <mat-select [disabled]="true" [formControl]="formGroup.controls.largeDisabled">
              <mat-select-trigger>
                <span>
                  {{ formGroup.controls.largeDisabled?.value?.displayKey }}
                </span>
              </mat-select-trigger>
              <mat-option *ngFor="let option of voucherOptions" [value]="option">{{
                option.displayKey
              }}</mat-option>
            </mat-select>
            <span mat-select-description>Description</span>
          </mat-form-field>
        </span>

        <span>
          Large control disabled with pre-selected value + description
          <mat-form-field mat-select-height-large>
            <mat-label>Select Simulator</mat-label>
            <mat-select [disabled]="true" [formControl]="formGroup.controls.largeDisabledValue">
              <mat-select-trigger>
                <span>
                  {{ formGroup.controls.largeDisabledValue?.value?.displayKey }}
                </span>
              </mat-select-trigger>
              <mat-option *ngFor="let option of voucherOptions" [value]="option">{{
                option.displayKey
              }}</mat-option>
            </mat-select>
            <span mat-select-description>Description</span>
          </mat-form-field>
        </span>

        <span>
          Large control with error + description
          <mat-form-field mat-select-height-large>
            <mat-label>Select Simulator</mat-label>
            <mat-select [formControl]="formGroup.controls.largeError">
              <mat-select-trigger>
                <span>
                  {{ formGroup.controls.largeError?.value?.displayKey }}
                </span>
              </mat-select-trigger>
              <mat-option *ngFor="let option of voucherOptions" [value]="option">{{
                option.displayKey
              }}</mat-option>
            </mat-select>
            <span mat-select-description>Description</span>
            <mat-error *ngIf="formGroup.controls.largeError.hasError('pattern')"
              >Incorrect value</mat-error
            >
          </mat-form-field>
        </span>

        <span>
          Large control with two errors + description
          <mat-form-field mat-select-height-large>
            <mat-label>Select Simulator</mat-label>
            <mat-select [formControl]="formGroup.controls.largeError">
              <mat-select-trigger>
                <span>
                  {{ formGroup.controls.largeError?.value?.displayKey }}
                </span>
              </mat-select-trigger>
              <mat-option *ngFor="let option of voucherOptions" [value]="option">{{
                option.displayKey
              }}</mat-option>
            </mat-select>
            <span mat-select-description>Description</span>
            <mat-error *ngIf="formGroup.controls.largeError.hasError('pattern')"
              >Incorrect value</mat-error
            >
            <mat-error *ngIf="formGroup.controls.largeError.hasError('pattern')"
              >Invalid Simulator</mat-error
            >
          </mat-form-field>
        </span>

        <span>
          Large frameless control
          <mat-form-field mat-select-height-large mat-select-frameless>
            <mat-label>Select Simulator</mat-label>
            <mat-select [formControl]="formGroup.controls.largeFrameless">
              <mat-select-trigger>
                <span>
                  {{ formGroup.controls.largeFrameless?.value?.displayKey }}
                </span>
              </mat-select-trigger>
              <mat-option *ngFor="let option of voucherOptions" [value]="option">{{
                option.displayKey
              }}</mat-option>
            </mat-select>
          </mat-form-field>
        </span>

        <span>
          Large frameless control with pre-selected value
          <mat-form-field mat-select-height-large mat-select-frameless>
            <mat-label>Select Simulator</mat-label>
            <mat-select [formControl]="formGroup.controls.largeFramelessValue">
              <mat-select-trigger>
                <span>
                  {{ formGroup.controls.largeFramelessValue?.value?.displayKey }}
                </span>
              </mat-select-trigger>
              <mat-option *ngFor="let option of voucherOptions" [value]="option">{{
                option.displayKey
              }}</mat-option>
            </mat-select>
          </mat-form-field>
        </span>

        <span>
          Large frameless control disabled
          <mat-form-field mat-select-height-large mat-select-frameless>
            <mat-label>Select Simulator</mat-label>
            <mat-select [disabled]="true" [formControl]="formGroup.controls.largeFramelessDisabled">
              <mat-select-trigger>
                <span>
                  {{ formGroup.controls.largeFramelessDisabled?.value?.displayKey }}
                </span>
              </mat-select-trigger>
              <mat-option *ngFor="let option of voucherOptions" [value]="option">{{
                option.displayKey
              }}</mat-option>
            </mat-select>
          </mat-form-field>
        </span>

        <span>
          Large frameless control disabled value
          <mat-form-field mat-select-height-large mat-select-frameless>
            <mat-label>Select Simulator</mat-label>
            <mat-select
              [disabled]="true"
              [formControl]="formGroup.controls.largeFramelessDisabledValue"
            >
              <mat-select-trigger>
                <span>
                  {{ formGroup.controls.largeFramelessDisabledValue?.value?.displayKey }}
                </span>
              </mat-select-trigger>
              <mat-option *ngFor="let option of voucherOptions" [value]="option">{{
                option.displayKey
              }}</mat-option>
            </mat-select>
          </mat-form-field>
        </span>

        <span>
          Large frameless control with error
          <mat-form-field mat-select-height-large mat-select-frameless>
            <mat-label>Select Simulator</mat-label>
            <mat-select [formControl]="formGroup.controls.largeFramelessError">
              <mat-select-trigger>
                <span>
                  {{ formGroup.controls.largeFramelessError?.value?.displayKey }}
                </span>
              </mat-select-trigger>
              <mat-option *ngFor="let option of voucherOptions" [value]="option">{{
                option.displayKey
              }}</mat-option>
            </mat-select>
            <mat-error *ngIf="formGroup.controls.largeFramelessError.hasError('pattern')"
              >Incorrect value</mat-error
            >
          </mat-form-field>
        </span>

        <span>
          Large frameless control with two error
          <mat-form-field mat-select-height-large mat-select-frameless>
            <mat-label>Select Simulator</mat-label>
            <mat-select [formControl]="formGroup.controls.largeFramelessError">
              <mat-select-trigger>
                <span>
                  {{ formGroup.controls.largeFramelessError?.value?.displayKey }}
                </span>
              </mat-select-trigger>
              <mat-option *ngFor="let option of voucherOptions" [value]="option">{{
                option.displayKey
              }}</mat-option>
            </mat-select>
            <mat-error *ngIf="formGroup.controls.largeFramelessError.hasError('pattern')"
              >Incorrect value</mat-error
            >
            <mat-error *ngIf="formGroup.controls.largeFramelessError.hasError('pattern')"
              >Invalid Simulator</mat-error
            >
          </mat-form-field>
        </span>

        <span>
          Large frameless control + description
          <mat-form-field mat-select-height-large mat-select-frameless>
            <mat-label>Select Simulator</mat-label>
            <mat-select [formControl]="formGroup.controls.largeFrameless">
              <mat-select-trigger>
                <span>
                  {{ formGroup.controls.largeFrameless?.value?.displayKey }}
                </span>
              </mat-select-trigger>
              <mat-option *ngFor="let option of voucherOptions" [value]="option">{{
                option.displayKey
              }}</mat-option>
            </mat-select>
            <span mat-select-description>Description</span>
          </mat-form-field>
        </span>

        <span>
          Large frameless control with pre-selected value + description
          <mat-form-field mat-select-height-large mat-select-frameless>
            <mat-label>Select Simulator</mat-label>
            <mat-select [formControl]="formGroup.controls.largeFramelessValue">
              <mat-select-trigger>
                <span>
                  {{ formGroup.controls.largeFramelessValue?.value?.displayKey }}
                </span>
              </mat-select-trigger>
              <mat-option *ngFor="let option of voucherOptions" [value]="option">{{
                option.displayKey
              }}</mat-option>
            </mat-select>
            <span mat-select-description>Description</span>
          </mat-form-field>
        </span>

        <span>
          Large frameless control disabled + description
          <mat-form-field mat-select-height-large mat-select-frameless>
            <mat-label>Select Simulator</mat-label>
            <mat-select [disabled]="true" [formControl]="formGroup.controls.largeFramelessDisabled">
              <mat-select-trigger>
                <span>
                  {{ formGroup.controls.largeFramelessDisabled?.value?.displayKey }}
                </span>
              </mat-select-trigger>
              <mat-option *ngFor="let option of voucherOptions" [value]="option">{{
                option.displayKey
              }}</mat-option>
            </mat-select>
            <span mat-select-description>Description</span>
          </mat-form-field>
        </span>

        <span>
          Large frameless control disabled value + description
          <mat-form-field mat-select-height-large mat-select-frameless>
            <mat-label>Select Simulator</mat-label>
            <mat-select
              [disabled]="true"
              [formControl]="formGroup.controls.largeFramelessDisabledValue"
            >
              <mat-select-trigger>
                <span>
                  {{ formGroup.controls.largeFramelessDisabledValue?.value?.displayKey }}
                </span>
              </mat-select-trigger>
              <mat-option *ngFor="let option of voucherOptions" [value]="option">{{
                option.displayKey
              }}</mat-option>
            </mat-select>
            <span mat-select-description>Description</span>
          </mat-form-field>
        </span>

        <span>
          Large frameless control with error + description
          <mat-form-field mat-select-height-large mat-select-frameless>
            <mat-label>Select Simulator</mat-label>
            <mat-select [formControl]="formGroup.controls.largeFramelessError">
              <mat-select-trigger>
                <span>
                  {{ formGroup.controls.largeFramelessError?.value?.displayKey }}
                </span>
              </mat-select-trigger>
              <mat-option *ngFor="let option of voucherOptions" [value]="option">{{
                option.displayKey
              }}</mat-option>
            </mat-select>
            <span mat-select-description>Description</span>
            <mat-error *ngIf="formGroup.controls.largeFramelessError.hasError('pattern')"
              >Incorrect value</mat-error
            >
          </mat-form-field>
        </span>

        <span>
          Large frameless control with two error + description
          <mat-form-field mat-select-height-large mat-select-frameless>
            <mat-label>Select Simulator</mat-label>
            <mat-select [formControl]="formGroup.controls.largeFramelessError">
              <mat-select-trigger>
                <span>
                  {{ formGroup.controls.largeFramelessError?.value?.displayKey }}
                </span>
              </mat-select-trigger>
              <mat-option *ngFor="let option of voucherOptions" [value]="option">{{
                option.displayKey
              }}</mat-option>
            </mat-select>
            <span mat-select-description>Description</span>
            <mat-error *ngIf="formGroup.controls.largeFramelessError.hasError('pattern')"
              >Incorrect value</mat-error
            >
            <mat-error *ngIf="formGroup.controls.largeFramelessError.hasError('pattern')"
              >Invalid Simulator</mat-error
            >
          </mat-form-field>
        </span>
      </div>
    </vi-panel>
  </vi-content>
</vi-page>
